import { useGetUserSettingInfo } from "@/api/services/main/user-setting";
import { IconEditor } from "@/assets/icons";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { Button } from "@/components/elements/Button";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { AccountInfo } from "@/features/user-setting/components/setting-info/AccountInfo";
import { EmailDeliveryInfo } from "@/features/user-setting/components/setting-info/EmailDeliveryInfo";
import { TGetUserSettingOutputDto } from "@/features/user-setting/dtos/get-user-setting.dto";
import { AppRoutes } from "@/routes/config";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const UserSettingDetailPage = () => {
  const { isLoading, data: userSettingResult } = useGetUserSettingInfo();
  const navigate = useNavigate();

  if (isLoading || !userSettingResult?.data) {
    return <LoadingPage />;
  }

  return (
    <>
      <Stack
        gap={1}
        sx={{
          minHeight: "calc(100vh - 194px)",
        }}
      >
        <TopPage
          title="ユーザー設定"
          subTitle={
            <Box
              sx={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {`${userSettingResult?.data?.userFullName} 様のユーザー情報を確認・編集できます。`}
            </Box>
          }
          enablePageBack={false}
        />
        <Stack gap={4} mt={2} mb={2}>
          <AccountInfo user={userSettingResult?.data as TGetUserSettingOutputDto} />
          <EmailDeliveryInfo />
        </Stack>
      </Stack>
      <FooterContainer>
        <Stack gap={1} direction="row" justifyContent="flex-end" alignItems="center">
          <Button variant="outline" size="sm" onClick={() => navigate(AppRoutes.userSettingEdit)} startIcon={<IconEditor />}>
            編集
          </Button>
        </Stack>
      </FooterContainer>
    </>
  );
};
